export default "__VITE_ASSET__994b1935__"